// src/components/SummaryCard.js
import React from 'react';
import { Paper, Typography } from '@mui/material';
import { styled } from '@mui/system';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: 'center',
//   color: theme.palette.text.secondary,
}));

const SummaryCard = ({ title, value }) => {
  return (
    <StyledPaper>
      <Typography variant="subtitle1">{title}</Typography>
      <Typography variant="h4">{value}</Typography>
    </StyledPaper>
  );
};

export default SummaryCard;
